var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestMatrix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_7965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1723 41.3551V44.1966H5.15385C3.09385 44.1612 1.20154 42.4966 1 40.4289V7.71813C1.39692 5.54736 2.93538 4.1489 5.15385 4.00582L42.2277 4.00275C44.2523 3.91659 46.4938 5.87198 46.4938 7.92121V29.6443C45.6215 29.6427 44.7708 29.6427 43.8815 29.6427V8.8489C43.8815 7.89505 42.9554 6.90428 41.9954 6.84582H5.55692C4.58769 6.97198 3.85385 7.70428 3.72769 8.67198V39.4735C3.82154 40.4766 4.61077 41.2658 5.61538 41.3581",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0018 34.7117V35.2132C48.8787 35.4886 48.7757 35.7501 48.5557 35.9686L39.0834 45.4286C38.8757 45.6517 38.5941 45.7055 38.328 45.8178H37.8803L37.2095 45.4563L31.4557 39.7055C30.368 38.4994 31.7587 36.7486 33.1834 37.6455L38.1326 42.524L46.5695 34.0963C47.4172 33.2224 48.6818 33.5547 49.0018 34.7117Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4922 23.6335C23.103 23.8858 23.7107 24.252 24.2522 24.6305C26.8276 26.4351 28.6091 29.3935 28.9384 32.5382C29.0261 33.3782 29.1845 34.3889 28.3768 34.9351C27.5353 35.5043 26.3414 34.9812 26.2138 33.9828C25.9922 32.2658 26.0507 31.3458 25.1738 29.7428C21.8845 23.7366 13.0076 24.0382 10.1676 30.2643C9.54452 31.632 9.57529 32.4335 9.40606 33.8551C9.21991 35.4243 7.17375 35.6274 6.68914 34.2812C6.51375 33.7935 6.63221 32.7951 6.70145 32.2551C7.17068 28.5582 9.72452 25.1105 13.1399 23.632C9.32914 20.212 10.3461 13.8966 15.1168 11.9458C20.4753 9.75507 25.963 14.5305 24.5907 20.1305C24.2553 21.4982 23.4814 22.6566 22.4922 23.632V23.6335ZM17.6014 14.1982C14.1476 14.3674 12.3507 18.4643 14.5938 21.1105C16.4461 23.2951 19.9445 23.0105 21.4122 20.5566C23.1245 17.6951 20.9261 14.0351 17.5999 14.1982H17.6014Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2747 13.3984H31.5547V15.8661H40.2747V13.3984Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2747 20.8555H31.5547V23.3232H40.2747V20.8555Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2747 28.3086H31.5547V30.7763H40.2747V28.3086Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_7965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 41.9138,
    fill: "white",
    transform: "translate(1 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestMatrix);
export default __webpack_public_path__ + "static/media/test_matrix.e8d623bb131bb18fdecbe74b1810a263.svg";
export { ForwardRef as ReactComponent };